import UpcomingSportPage from './UpcomingSportPage';

const UpcomingSoccerPage = () => <UpcomingSportPage sport="soccer" />;

export default UpcomingSoccerPage;
